class TSHeader extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector("#TSHeaderSearch");
    this.predictiveSearch = this.querySelector("div:not(.ts-header__search-wrapper--mobile) ts-predictive-search");
    this.searchButton = this.querySelector("div:not(.ts-header__search-wrapper--mobile) .ts-header__search-button");

    this.searchInputMobile = this.querySelector("#TSHeaderSearch-Mobile");
    this.predictiveSearchMobile = this.querySelector(".ts-header__search-wrapper--mobile ts-predictive-search");
    this.searchButtonMobile = this.querySelector(".ts-header__search-wrapper--mobile .ts-header__search-button");
    this.mobileMenu = this.querySelector(".ts-header__mobile");

    this.style.setProperty("--header-height", this.offsetHeight - 40 + 'px');
    
    if (this.searchInput && this.predictiveSearch) {
      this.setupSearchListeners();

      this.searchButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.searchInput.value = "";
        this.predictiveSearch.onChange(this.searchInput.value);
      })
    }

    if (this.searchInputMobile && this.predictiveSearchMobile) {
      this.setupMobileSearchListeners();

      this.searchButtonMobile.addEventListener("click", (e) => {
        e.preventDefault();
        this.searchInputMobile.value = "";
        this.predictiveSearch.onChange(this.searchInputMobile.value);
      })
    }

    // Обработка ховера для мега-меню
    const megamenuTriggers = this.querySelectorAll("[data-trigger='megamenu']");
    megamenuTriggers.forEach(trigger => {
      trigger.addEventListener("mouseenter", () => {
        this.querySelector("[data-trigger='megamenu'].active")?.classList.remove("active");
        trigger.classList.add("active");
      });
    });

    // Добавляем обработчик ухода мыши с области мега-меню
    this.addEventListener("mouseleave", (e) => {
      if (!e.target.closest("[data-trigger='megamenu']")) {
        this.querySelector("[data-trigger='megamenu'].active")?.classList.remove("active");
      }
    });

    this.addEventListener("click", (e) => {
      switch (e.target.dataset.trigger) {
        case 'open':
          this.mobileMenu.classList.toggle("open");
          if (this.mobileMenu.classList.contains("open")) {
            document.documentElement.style.overflow = "hidden";
            this.classList.add("reverse");
          } else {
            document.documentElement.style.overflow = null;
            this.classList.remove("reverse");
          }
          break;
        case 'close':
          document.documentElement.style.overflow = null;
          this.mobileMenu.classList.remove("open");
          this.classList.remove("reverse");
          break;
        case 'nested':
          e.target.nextElementSibling.classList.add("open");
          break;
        case 'back':
          e.target.closest("[data-nested]")?.classList.remove("open");
          break;
        case 'localization':
          this.mobileMenu.scrollTop = 0;
          e.target.nextElementSibling.classList.toggle("open");
          break;
        case 'locale-back':
          e.target.closest("ul.open").classList.remove("open");
          break;
        case 'country':
          const form = e.target.closest("form");
          form.querySelector("input[name='country_code']").value = e.target.dataset.value;
          form.submit();
          break;
      }
    })

    this.addEventListener("mouseover", (e) => {
      if (e.target.dataset.handle && e.target.classList.contains("ts-megamenu__menu-link")) {
        this.querySelector(".ts-megamenu__nested.active[data-handle]")?.classList.remove('active');
        this.querySelector(".ts-megamenu__menu-link.active[data-handle]")?.classList.remove('active');
        
        if (this.querySelector(`.ts-megamenu__nested[data-handle="${e.target.dataset.handle}"]`)) {
          e.target.classList.add("active");
          this.querySelector(`.ts-megamenu__nested[data-handle="${e.target.dataset.handle}"]`).classList.add("active");
        }
      }
    })

    window.addEventListener("click", (e) => {
      if (!e.target.closest(".ts-header__country.ts-country")) {
        this.querySelector(".ts-country__list").classList.remove("open");
      }
    })
  }

  setupSearchListeners() {
    this.searchInput.addEventListener("focus", () => {
      this.predictiveSearch.classList.add('open');
      document.documentElement.style.overflow = null;
      this.mobileMenu.classList.remove("open");
      this.classList.remove("reverse");

      const searchValue = this.searchInput.value.trim();
      if (searchValue !== '' && searchValue !== this.predictiveSearch.currentTerms) {
        this.predictiveSearch.onChange(this.searchInput.value);
      }
    }) 

    window.addEventListener("click", (e) => {
      if (!e.target.closest(".ts-header__search-predictive") && !e.target.closest(".ts-header__search-wrapper")) {
        this.predictiveSearch.classList.remove('open');
      }
    }) 

    this.searchInput.addEventListener(
      "keyup", 
      debounce(() => {
        this.predictiveSearch.onChange(this.searchInput.value);
      }, 500).bind(this)
    );
  }

  setupMobileSearchListeners() {
    this.searchInputMobile.addEventListener("focus", () => {
      this.predictiveSearchMobile.classList.add('open');
      document.documentElement.style.overflow = null;
      this.mobileMenu.classList.remove("open");
      this.classList.remove("reverse");

      const searchValue = this.searchInputMobile.value.trim();
      if (searchValue !== '' && searchValue !== this.predictiveSearchMobile.currentTerms) {
        this.predictiveSearchMobile.onChange(this.searchInputMobile.value);
      }
    }) 

    window.addEventListener("click", (e) => {
      if (!e.target.closest(".ts-header__search-predictive") && !e.target.closest(".ts-header__search-wrapper")) {
        this.predictiveSearchMobile.classList.remove('open');
      }
    }) 

    this.searchInputMobile.addEventListener(
      "keyup", 
      debounce(() => {
        this.predictiveSearchMobile.onChange(this.searchInputMobile.value);
      }, 500).bind(this)
    );
  }
}

customElements.define("ts-header", TSHeader);